import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MapDetailService } from '../../../services/map-detail.service';


interface stopList {
  StopName:string,
  seqNo:string,
  detail:string
}


interface BusTrain {
  name:string;
  endStop: string;
  detail: string;
  stopList: stopList[]
}

@Component({
  selector: 'bus-traffic',
  standalone: true,
  template:`
<div class="detail collapse {{ state }}" id="bus">
  <div class="card card-body">
    <a (click)="close()" role="button" aria-expanded="false" aria-controls="bus" class="bt-close">
      <span aria-hidden="true" class="close">×</span>
    </a>
    <div class="site-tt">站點資訊</div>
    @if(!ifRoute){
      <ul class="box bus">
        <li class="titbox">
          <div class="m-title"><img src="/static/images/svg/map_w_bus.svg" alt="">市區公車</div>
          <div class="s-title"><p>{{ name }}</p><a (click)="getTrain()" role="button"><img src="/static/images/svg/ic_reset.svg" alt=""></a></div>
        </li>

        @for (busTrain of BusTrainList; track $index) {
        <li class="timelist link">
          <a (click)="getRoute(busTrain)">
          <p class="t-number"><span>{{ busTrain.name }}</span>往 {{ busTrain.endStop }}</p>
          <div class="time">
          <span class="arrow"></span>
            <p class="next">{{ busTrain.detail }}</p>
          </div>
          </a>
        </li>
        }
      </ul>
    }
    @if(ifRoute){
    <div class="btn-back"><a (click)="back()">回上頁</a></div>
    <ul class="box bus">
      <li class="titbox">
        <div class="m-title"><img src="/static/images/svg/map_w_bus.svg" alt=""><p>{{ BusRoute.name }}</p></div>
        <div class="s-title"><p>往 {{ BusRoute.endStop }}</p><a (click)="getTrain()" role="button"><img src="/static/images/svg/ic_reset.svg" alt=""></a></div>
	    </li>
      @for (busStop of BusRoute.stopList; track $index) {
      <li class="timelist">
        <p class="t-number">{{busStop.StopName}}</p>
        <div class="time">
          <span class="arrow"></span>
          <p class="next">{{busStop.detail}}</p>
        </div>
      </li>
      }
    </ul>
    }
  </div>
</div>
  `
})

export class BusTrafficComponent {

  // [ClienteService] 定義服務
  constructor(private mapDetailService: MapDetailService) {
  }

  @Input() name: string = "";
  @Input() stationId: string = "";
  @Output() callBack =  new EventEmitter<void>();
  state: string = "";
  ifRoute: boolean = false;
  BusTrainList: BusTrain[] = [];
  BusRoute: BusTrain;
  endStop:string ="";

  ngOnChanges(){
    this.state = "show";
    if(this.state = "show") {
      this.getTrain();
      this.ifRoute = false;
    }
  }
  close(){
    this.callBack.emit();
  }


  getTrain() {
    this.mapDetailService.getBus(this.stationId).subscribe((BusArray:any) => {
      this.BusTrainList = [];
      for(let bus of BusArray){

        this.BusTrainList.push({
          name:     bus.name,
          endStop:  bus.endStop,
          detail:   bus.detail,
          stopList: bus.stopList
        });

        if(bus.name === this.BusRoute?.name){
          this.BusRoute = {
            name:     bus.name,
            endStop:  bus.endStop,
            detail:   bus.detail,
            stopList: bus.stopList
          };
        }
      }
    });
  }

  getRoute(busTrain:BusTrain){
    this.ifRoute = true;
    this.BusRoute = busTrain;
  }

  back(){
    this.ifRoute = false;
  }



}
